"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Input.module.css"));
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", null,
            React.createElement("input", { className: css, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: type, placeholder: placeholder, disabled: disabled }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    Input.defaultProps = {
        type: "text",
        errors: {}
    };
    return Input;
}(react_1.Component));
exports.Input = Input;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0lucHV0L0lucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQix5REFBNEM7QUFZNUM7SUFBMkIseUJBQW9CO0lBQS9DOztJQWtDQSxDQUFDO0lBNUJVLHNCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQTJFLEVBQTFFLFVBQUUsRUFBRSx3QkFBUyxFQUFFLHNCQUFRLEVBQUUsY0FBSSxFQUFFLDRCQUFXLEVBQUUsc0JBQVEsRUFBRSxrQkFBb0IsQ0FBQTtRQUVqRixJQUFNLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQ2pDLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV4QixJQUFJLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBO1FBQ3JCLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1NBQ3JDO1FBRUQsT0FBTyxDQUNIO1lBQ0ksK0JBQ0ksU0FBUyxFQUFFLEdBQUcsRUFDZCxFQUFFLEVBQUUsRUFBRSxFQUNOLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixRQUFRLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Z0JBQ3BDLENBQUMsRUFDRCxJQUFJLEVBQUUsSUFBSSxFQUNWLFdBQVcsRUFBRSxXQUFXLEVBQ3hCLFFBQVEsRUFBRSxRQUFRLEdBQ3BCO1lBQ0QsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFoQ2Esa0JBQVksR0FBRztRQUN6QixJQUFJLEVBQUUsTUFBTTtRQUNaLE1BQU0sRUFBRSxFQUFFO0tBQ2IsQ0FBQTtJQThCTCxZQUFDO0NBQUEsQUFsQ0QsQ0FBMkIsaUJBQVMsR0FrQ25DO0FBbENZLHNCQUFLIn0=